import React from "react";

// reactstrap components
import { Container, Row } from "reactstrap";

const CheckoutHistoryHeader = () => {
  return (
    <>
      <div className="header bg-gradient-indigo pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default CheckoutHistoryHeader;
